export const FORM_ADD_USER = {
  EMAIL: "email_user",
  NAME: "name_user",
  MOBILE: "mobile_user",
  GROUP: "group_user",
  ROLE: "role_user",
};

export const NEW_USER_ERROR = "New user is not created. Please try later.";
